import { blur, draw, fade, fly, scale, slide } from 'svelte/transition'

export const AnimIN = node => scale(node, {
    duration: 300,
    delay: 350,
})

export const AnimOUT = node => scale(node, {
    duration: 300,
    delay: 0,
})